import route from "../../router";
import { ucfirst } from '../../utils/strings';

export default {
  props: {
    tripId: {
      type: Number,
      required: false
    },
    image: {
      type: String,
      required: true
    },
    alt_image: {
      type: String
    },
    title: {
      type: String,
      required: true
    },
    price: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      showTextPrice: route.currentRoute.params.origin,
      ucfirst,
    }
  },
  methods: {
    handleLinkClick() {
      this.$emit('linkClicked', this.tripId);
    }
  }
};
